import appGlobalScript from 'C:/data/Daten/desi-code/stzh-components/src/global/js/script.js';
export const globalScripts = appGlobalScript;
